import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const TESTING_AND_EXPERIMENTING_CONTEXT = createContext(null);

TestingProvider.propTypes = {
  toBeTested: PropTypes.instanceOf(Object),
};

export function TestingProvider({
  children,
  toBeTested = { subscriptionFormAB: false },
}) {
  return (
    <TESTING_AND_EXPERIMENTING_CONTEXT.Provider value={toBeTested}>
      {children}
    </TESTING_AND_EXPERIMENTING_CONTEXT.Provider>
  );
}

export const useTestingProvider = () =>
  useContext(TESTING_AND_EXPERIMENTING_CONTEXT);
